import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';

export const groupsApi = createApi({
    reducerPath: 'groups',
    baseQuery: createBaseQueryWithReauth('/groups'),

    tagTypes: ['Groups'],

    endpoints: builder => ({
        getGroups: builder.query({
            query: (shop_id) => ({
                url: `/list${shop_id ? `?shop_id=${shop_id}` : ''}`,
                method: 'GET',
            }),
            providesTags: ['Groups'],
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            refetchOnFocus: true,
            refetchOnReconnect: true,
        }),

        createGroup: builder.mutation({
            query: ({ shop_id, ...data }) => ({
                url: `/create?shop_id=${shop_id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Groups'],
        }),

        updateGroup: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `/update?id=${id}`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Groups'],
        }),

        deleteGroup: builder.mutation({
            query: (id) => ({
                url: `/delete?id=${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['Groups'],
        }),
    }),
});

export const {
    useGetGroupsQuery,
    useCreateGroupMutation,
    useUpdateGroupMutation,
    useDeleteGroupMutation,
} = groupsApi;